import { DatosResumenCuentaCorriente } from '../../../../models/IResumenCuentaCorrienteResponse';
import * as types from '../../../../system/types'

export interface ResumenCuentaCorrienteState {
    id: string,
    // errors: [],
    inProgress: boolean,
    data: Array<DatosResumenCuentaCorriente> | null,
    message?: string | null
}

const ResumenCuentaCorrienteInitialState: ResumenCuentaCorrienteState = {
    id: '',
    // errors: [],
    data: null,
    inProgress: false
};

export default function resumenCuentaCorrienteReducer(
    state: ResumenCuentaCorrienteState = ResumenCuentaCorrienteInitialState,
    action: types.RootAction
): ResumenCuentaCorrienteState {
    switch (action.type) {
        case types.RESUMENCUENTACORRIENTE_REQUEST:
            return {
                ...state,
                message: '',
                inProgress: true
            }
        case types.RESUMENCUENTACORRIENTE_RESPONSE:
            return {
                ...state,
                data: action.data,
                message: action.message,
                inProgress: false
            }
        case types.RESUMENCUENTACORRIENTE_FAILED:
            return {
                ...state,
                message: action.message,
                inProgress: false
            }
        default:
            return state;
    }
}